export class TipoCondicion {
    constructor(
        public id?: number,
        public descripcion?: string,
        public texto?: string // el texto es variable según la cotizacion
    ) { }
}
